import React from 'react';
import { FormComponent, UiComponent } from 'components';
import { IOrganization } from 'types';
import { OrganizationQuery, FileServiceQuery } from 'queries';
import useModal from 'hooks/useModal';
import useFileService from 'hooks/useFileService';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';

interface Props {
  organization: IOrganization | null;
}

function OrganizationForm({ organization }: Props) {
  const { handleClose } = useModal();
  const { mutateAsync: create } = OrganizationQuery.useCreate();
  const { mutateAsync: update } = OrganizationQuery.useUpdate();
  const { handleUploadd: upload } = FileServiceQuery.useUpload();
  const { fileUrl, file, handleFile } = useFileService({
    initFileUrl: organization?.logoUrl ?? '',
  });

  const handleSubmit = async (data: IOrganization) => {
    try {
      let logoUrl = organization?.logoUrl ?? null;

      if (file) {
        const res = await upload(file);
        if (!res) return;
        logoUrl = res.data.url;
      }

      if (organization) {
        await update({ ...data, id: organization.id, logoUrl });
        toast.success('단체가 수정되었습니다.');
      } else {
        await create({ ...data, logoUrl: logoUrl ?? undefined });
        toast.success('단체가 등록되었습니다.');
      }
    } catch {
      toast.error(DEFAULT_ERROR_MESSAGE);
      return;
    } finally {
      handleClose();
    }
  };

  return (
    <FormComponent.Form
      css={{
        width: '400px',
        '> input': { width: '100%' },
        '> textarea': { width: '100%' },
        '> p': { margin: '16px 0', fontWeight: '600' },
      }}
      submit={handleSubmit}
    >
      <p>내부 식별자 (영문 slug)</p>
      <FormComponent.Input
        name="name"
        defaultValue={organization?.name}
        placeholder="예: yvis-hq"
      />
      <p>표시명</p>
      <FormComponent.Input
        name="displayName"
        defaultValue={organization?.displayName}
      />
      <p>설명</p>
      <FormComponent.Textarea
        name="description"
        defaultValue={organization?.description}
      />
      <p>로고 이미지</p>
      <UiComponent.FileUpload
        name="logoUrl"
        fileUrl={fileUrl}
        handleFile={handleFile}
      />
      <div css={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
        <UiComponent.Button type="submit" variant="contained" color="primary">
          {organization ? '수정하기' : '등록하기'}
        </UiComponent.Button>
      </div>
    </FormComponent.Form>
  );
}

export default OrganizationForm;
